const DEFAULT_WAIT_MS = 1000;

async function requestHttpCacheId(window, url) {
    try {
        const fetchFn = window?.fetch;
        if (typeof fetchFn !== 'function' || typeof url !== 'string' || !url) {
            return null;
        }

        const response = await fetchFn.call(window, url, {
            method: 'GET',
            cache: 'force-cache',
            credentials: 'omit',
            mode: 'cors',
        });
        if (!response?.ok || typeof response.json !== 'function') {
            return null;
        }

        const body = await response.json();
        return typeof body?.id === 'string' && body.id !== '' ? body.id : null;
    } catch (error) {
        void error;
        return null;
    }
}

/**
 * Получает ID из приватного HTTP-кэша, не задерживая fingerprint надолго.
 * Поздний fetch не отменяется и может прогреть кэш для следующего визита.
 * @param {Window} window
 * @param {string} url
 * @param {number} waitMs
 * @returns {Promise<string|null>}
 */
export default async function collectHttpCacheId(window, url, waitMs = DEFAULT_WAIT_MS) {
    let timeoutId;
    let clearTimer;

    try {
        const windowSetTimer = window?.setTimeout;
        const windowClearTimer = window?.clearTimeout;
        const setTimer = typeof windowSetTimer === 'function'
            ? windowSetTimer.bind(window)
            : setTimeout;
        clearTimer = typeof windowClearTimer === 'function'
            ? windowClearTimer.bind(window)
            : clearTimeout;
        const timeout = new Promise(resolve => {
            timeoutId = setTimer(() => resolve(null), waitMs);
        });

        return await Promise.race([
            requestHttpCacheId(window, url),
            timeout,
        ]);
    } catch (error) {
        void error;
        return null;
    } finally {
        if (typeof clearTimer === 'function' && typeof timeoutId !== 'undefined') {
            try {
                clearTimer(timeoutId);
            } catch (error) {
                void error;
            }
        }
    }
}
